import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface ManualEmployeesSelectorProps {
  value: string[]
  onChange: (ids: string[]) => void
  excludeIds?: string[]
}

export const ManualEmployeesSelector = ({
  value,
  onChange,
  excludeIds = [],
}: ManualEmployeesSelectorProps) => {
  const handleChange = (state: EmployeeSelectorV2MultiSelectState) => {
    // With disableSelectAll: true, state.type is always 'manual'
    if (state.type === 'manual') {
      onChange(state.ids)
    }
  }

  return (
    <EmployeeSelectorV2
      multiple
      value={value}
      onChange={handleChange}
      label={i18n.t('workflows.sidepanel.approval.strategies.selectors.employees')}
      options={{
        hideLabel: true,
        size: 'md',
        disableSelectAll: true,
      }}
      forcedFilters={{
        withVerb: 'ProcurementSeePurchaseRequests',
        ...(excludeIds.length > 0 && { excludeIds }),
      }}
      messages={{
        placeholder: i18n.t(
          'workflows.sidepanel.approval.strategies.selectors.employees_placeholder'
        ),
        searchBoxPlaceholder: i18n.t(
          'workflows.sidepanel.approval.strategies.selectors.employees_search_placeholder'
        ),
        searchEmptyMessage: i18n.t(
          'workflows.sidepanel.approval.strategies.selectors.employees_not_found'
        ),
      }}
    />
  )
}
